module.exports = __webpack_public_path__ + "static/media/flat.595c0b81.jpg";